

module user {
  'use strict';

  export class ForgotPasswordCtrl {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      'userService',
      '$timeout',
      '$mdDialog',
      'debounce',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: IForgotPasswordController,
      private userService: user.UserService,
      private $timeout: ng.ITimeoutService,
      private $mdDialog: ng.material.IDialogService,
      private debounce: navigation.IDebounceService
    ) {

      $scope.vm = this; 
      $scope.error = false;
      $scope.success = false;

    }

    resetPassword() {
      //sende reset passwort anfrage
      //blende Meldung ein. Email-Adresse muss integriert sein dass der nutzer evt. fehler Sieht. 
      var addr = this.$scope.loginform.email.$modelValue;
      
      if (this.$scope.loginform.email.$invalid) return;
      this.userService.resetPassword(this.$scope.login.email).then((response) => { 
        this.$scope.success = true;
      }).catch((e)=> {
        this.$scope.error = true;
      });
    }

    closeDialog() {
      this.$mdDialog.hide();
    }

    cancelDialog() {
      this.$mdDialog.cancel();
    };

  }
};
